<script>
// ReportsFiltersAgents.vue
import { mapGetters } from 'vuex';
import AgentAPI from 'dashboard/api/agents';

export default {
  name: 'ReportsFiltersAgents',
  props: {
    // 🔥 NOVA PROP: Array de IDs de agentes permitidos
    filteredAgentIds: {
      type: Array,
      default: null, // null = mostra todos os agentes
    },
    // Inclui as cascas de IA (is_human=false) na lista — o CSAT (e qualquer
    // relatório onde agente de IA é avaliável) liga isto. A lista do store
    // `agents/getAgents` vem do endpoint que filtra `is_human: true`, então
    // aqui buscamos a lista completa localmente, sem mexer no store global
    // (que alimenta dropdowns de atribuição do app inteiro).
    includeNonHuman: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['agentsFilterSelection'],
  data() {
    return {
      selectedOptions: [],
      fullAgentList: [],
    };
  },
  computed: {
    ...mapGetters({
      allAgents: 'agents/getAgents',
    }),

    baseAgents() {
      if (this.includeNonHuman && this.fullAgentList.length) {
        return this.fullAgentList;
      }
      return this.allAgents;
    },

    // 🔥 COMPUTED: Retorna agentes filtrados ou todos
    options() {
      // Se não houver filtro, retorna todos os agentes
      if (!this.filteredAgentIds || this.filteredAgentIds.length === 0) {
        return this.baseAgents;
      }

      // Filtra apenas agentes cujo ID está na lista permitida
      return this.baseAgents.filter(agent =>
        this.filteredAgentIds.includes(agent.id)
      );
    },
  },
  watch: {
    // 🔥 WATCH: Limpa seleções inválidas quando o filtro muda
    filteredAgentIds(newIds) {
      if (!newIds || newIds.length === 0) {
        // Se não há filtro, mantém todas as seleções
        return;
      }

      // Remove agentes selecionados que não estão mais disponíveis
      const validSelections = this.selectedOptions.filter(agent =>
        newIds.includes(agent.id)
      );

      if (validSelections.length !== this.selectedOptions.length) {
        this.selectedOptions = validSelections;
        this.handleInput();
      }
    },
  },
  async mounted() {
    this.$store.dispatch('agents/get');
    if (!this.includeNonHuman) return;
    try {
      const { data } = await AgentAPI.listAll();
      this.fullAgentList = data;
    } catch {
      // Sem a lista completa, o filtro degrada pra lista do store (só
      // humanos) — o dropdown continua funcional, só sem as cascas de IA.
    }
  },
  methods: {
    handleInput() {
      this.$emit('agentsFilterSelection', this.selectedOptions);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOptions"
      class="no-margin"
      :options="options"
      track-by="id"
      label="name"
      multiple
      :close-on-select="false"
      :clear-on-select="false"
      hide-selected
      :placeholder="$t('CSAT_REPORTS.FILTERS.AGENTS.PLACEHOLDER')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
      @update:model-value="handleInput"
    />
  </div>
</template>
